import { Card, Col, Container, Row } from "react-bootstrap";
import { DashboardMetric } from "..";
import { useNavigate } from "react-router-dom";
import { Icon, LoadingSpinner, fas } from "../../../component-library";
import { useShipmentQuery } from "../../../queries";
import { Lists } from "../../lists";

export function ShipmentsDashboard() {
    const navigate = useNavigate();
    const { dashboardQuery } = useShipmentQuery({ queryType: "dashboard" });
    const { data } = dashboardQuery;

    if (dashboardQuery.isFetching) return <LoadingSpinner />;

    return (
        <Container>
            <h1>Shipments</h1>

            <Row className="gx-3">
                <Col lg={9} className="mb-2">
                    <Card className="bg-primary text-white">
                        <Card.Header>Incoming</Card.Header>
                        <Card.Body className="bg-canvas">
                            <Row>
                                <Col>
                                    <DashboardMetric
                                        title={
                                            <span>
                                                Recovered Tissues{" "}
                                                <Icon
                                                    icon={fas.faInfoCircle}
                                                    title="Recently recovered tissues sent from regional offices to selected offices"
                                                    aria-label="Recently recovered tissues sent from regional offices to selected offices"
                                                    className="text-primary"
                                                />
                                            </span>
                                        }
                                        value={data?.incomingRecoveredTissues ?? "-"}
                                        onClick={() => navigate(`/lists/${Lists.ShipmentsRecoveredTissues}/shipments`)}
                                    />
                                </Col>

                                <Col>
                                    <DashboardMetric
                                        title={
                                            <span>
                                                Satellite Transfers{" "}
                                                <Icon
                                                    icon={fas.faInfoCircle}
                                                    title="Incoming tissues sent from main offices to selected offices"
                                                    aria-label="Incoming tissues sent from main offices to selected offices"
                                                    className="text-primary"
                                                />
                                            </span>
                                        }
                                        value={data?.incomingSatelliteTransfers ?? "-"}
                                        onClick={() =>
                                            navigate(`/lists/${Lists.ShipmentsSatelliteTransfers}/shipments`)
                                        }
                                    />
                                </Col>

                                <Col>
                                    <DashboardMetric
                                        title={
                                            <span>
                                                Imports and Returns{" "}
                                                <Icon
                                                    icon={fas.faInfoCircle}
                                                    title="Incoming tissues sent from external sources to selected offices"
                                                    aria-label="Incoming tissues sent from external sources to selected offices"
                                                    className="text-primary"
                                                />
                                            </span>
                                        }
                                        value={data?.incomingExternalShipments ?? "-"}
                                        onClick={() => navigate(`/lists/${Lists.ShipmentsExternal}/shipments`)}
                                    />
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
                <Col lg={3} className="mb-2">
                    <Card className="bg-primary text-white">
                        <Card.Header>Outgoing</Card.Header>
                        <Card.Body className="bg-canvas">
                            <Row>
                                <Col>
                                    <DashboardMetric
                                        title={
                                            <span>
                                                To Be Shipped{" "}
                                                <Icon
                                                    icon={fas.faInfoCircle}
                                                    title="Tissues to be shipped from selected offices"
                                                    aria-label="Tissues to be shipped from selected offices"
                                                    className="text-primary"
                                                />
                                            </span>
                                        }
                                        value={data?.toBeShipped ?? "-"}
                                        onClick={() => navigate(`/lists/${Lists.ShipmentsToBeShipped}/shipments`)}
                                    />
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}
